import React from 'react';
import { Link } from 'react-router-dom';
import { useBooking } from '../context/BookingContext';
import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
const COLLECTION_NUMBERS = ['01', '02', '03', '04'];
export const Landing = () => {
  const {
    villas
  } = useBooking();
  const featuredVilla = villas[0];
  return <main className="overflow-hidden bg-nordvik-ink text-white" data-id="element-241" data-mp="3pm7pjkw3yxke">
      <section className="nv-grid relative border-b border-white/10" data-id="element-242" data-mp="3umlxl2xpm7if">
        <div className="mx-auto grid min-h-[calc(100vh-80px)] max-w-[1440px] grid-cols-1 lg:grid-cols-12" data-id="element-243" data-mp="3gkkkou6p3u5">
          <div className="relative z-10 flex flex-col justify-between px-6 py-12 sm:px-8 lg:col-span-7 lg:px-12 lg:py-16" data-id="element-244" data-mp="87kdzk43h3rw">
            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.45
          }} data-id="element-245" data-mp="c8w7i0q3a95d">
              <p className="nv-label mb-8 text-nordvik-yellow" data-id="element-246" data-mp="m6sd6d09cbw3">Latitude 07° / private pool residences</p>
              <h1 className="max-w-3xl text-5xl font-black uppercase leading-[0.88] tracking-[-0.055em] text-white sm:text-6xl lg:text-[84px]" data-id="element-247" data-mp="2b39ca98ygl2">
                The quiet is
                <span className="block text-nordvik-orange" data-id="element-248" data-mp="3pe82kubhxi3t">already yours.</span>
              </h1>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-249" data-mp="3kg6kablw9mte">
                Four secluded villas. Open-air water. A stay that runs at its own pace from first light to the last swim.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.45,
            delay: 0.12
          }} className="mt-12 flex flex-wrap items-center gap-5" data-id="element-250" data-mp="h115bcdf4akt">
              <a href="#collection" className="nv-focus inline-flex items-center gap-4 rounded-none bg-nordvik-orange px-6 py-4 text-xs font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-white hover:text-nordvik-ink nv-glow" data-id="element-251" data-mp="14or0m96x11mb">
                Explore collection <ArrowDownRight className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="1nt489d22zxpe" />
              </a>
              <Link to="/agent/login" className="nv-focus border-b border-white/30 pb-1 text-xs uppercase tracking-[0.17em] text-white/65 transition-colors hover:border-white hover:text-white" data-id="element-253" data-mp="1a1pfwfmaak5o">
                Agent desk
              </Link>
            </motion.div>

            <div className="mt-16 grid max-w-xl grid-cols-3 border-t border-white/15 pt-5" data-id="element-254" data-mp="101yncjhaaf88">
              <div data-id="element-255" data-mp="1547hhj5w7nbx">
                <p className="text-2xl font-black tracking-tight text-white" data-id="element-256" data-mp="150jn6hsmiww5">04</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.15em] text-white/45" data-id="element-257" data-mp="r4fyf40irgr2">Residences</p>
              </div>
              <div className="border-l border-white/15 pl-5" data-id="element-258" data-mp="v69suuk4fois">
                <p className="text-2xl font-black tracking-tight text-white" data-id="element-259" data-mp="2li7d4hxpgqtd">24/7</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.15em] text-white/45" data-id="element-260" data-mp="2phg63kkx8knv">Host support</p>
              </div>
              <div className="border-l border-white/15 pl-5" data-id="element-261" data-mp="dvnuqil45frx">
                <p className="text-2xl font-black tracking-tight text-white" data-id="element-262" data-mp="9ubz9wfk60bt">LIVE</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.15em] text-white/45" data-id="element-263" data-mp="nknva6f9kj88">Availability</p>
              </div>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          x: 36
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.65,
          delay: 0.08
        }} className="relative min-h-[470px] border-t border-white/10 lg:col-span-5 lg:min-h-0 lg:border-l lg:border-t-0" data-id="element-264" data-mp="iswc4gyftfs4">
            <img src={featuredVilla?.image} alt={featuredVilla?.name ?? 'Private pool villa'} className="absolute inset-0 h-full w-full object-cover opacity-80 grayscale-[20%]" data-id="element-265" data-mp="16hpbkne9q5rh" />
            <div className="absolute inset-0 bg-gradient-to-t from-nordvik-ink via-nordvik-ink/10 to-transparent" data-id="element-266" data-mp="38bolp5fnmh2l" />
            <div className="absolute inset-x-5 bottom-5 nv-shell" data-id="element-267" data-mp="33dwhbbxtp2hi">
              <Link to={`/villa/${featuredVilla?.id ?? 'v1'}`} className="nv-glass nv-focus block rounded-md p-5 transition-colors hover:bg-nordvik-ink/85" data-id="element-268" data-mp="35pozsmaz8jyq">
                <p className="nv-label text-nordvik-yellow" data-id="element-269" data-mp="3erezeff0ip7l">Open now / featured residence</p>
                <div className="mt-4 flex items-end justify-between gap-4" data-id="element-270" data-mp="3eplognxd9its">
                  <div data-id="element-271" data-mp="3jpq8gnxhgvor">
                    <h2 className="text-2xl font-black uppercase tracking-tight text-white" data-id="element-272" data-mp="2m2rb0ayyvjpt">{featuredVilla?.name}</h2>
                    <p className="mt-1 text-sm text-white/60" data-id="element-273" data-mp="2r1awka9nethn">From ${featuredVilla?.nightlyRate} / night</p>
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-nordvik-orange" aria-hidden="true" data-id="element-274" data-mp="2w05fdc7m8i1r" />
                </div>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section id="collection" className="mx-auto max-w-[1440px] px-6 py-20 sm:px-8 lg:px-12 lg:py-28" data-id="element-275" data-mp="23bgm1zcsxh0k">
        <div className="mb-12 flex flex-col justify-between gap-6 border-b border-white/15 pb-8 md:flex-row md:items-end" data-id="element-276" data-mp="289ruc5ng7jgo">
          <div data-id="element-277" data-mp="20pqybr3boxdh">
            <p className="nv-label text-nordvik-orange" data-id="element-278" data-mp="1vsqsnhadxwmw">The atlas / 04 stays</p>
            <h2 className="mt-4 max-w-xl text-4xl font-black uppercase leading-[0.9] tracking-[-0.045em] text-white sm:text-5xl" data-id="element-279" data-mp="1vqnsw5jfkp4z">
              Pick a point on the map.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/55" data-id="element-280" data-mp="1lwnlfx0of7t3">Each residence is built around its own version of privacy: a horizon, a garden, a private deck, or an infinity edge.</p>
        </div>

        <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-2" data-id="element-281" data-mp="1d0ehq65o1n15">
          {villas.map((villa, index) => <motion.article key={villa.id} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.42
        }} className="group" data-id="element-282" data-mp="134bib82782hw" data-mpi={index}>
              <Link to={`/villa/${villa.id}`} className="nv-focus block rounded-sm" data-id="element-283" data-mp="jhrth73tl7sk">
                <div className="relative aspect-[16/10] overflow-hidden border border-white/15 bg-white/5" data-id="element-284" data-mp="ohct7jqtdk6c">
                  <img src={villa.image} alt={villa.name} className="h-full w-full object-cover opacity-75 transition-all duration-500 group-hover:scale-[1.03] group-hover:opacity-100 motion-reduce:transition-none motion-reduce:group-hover:scale-100" data-id="element-285" data-mp="ahuzcpynvgq4" />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-nordvik-ink/25 via-transparent to-transparent" data-id="element-286" data-mp="13728eivqropm" />
                  <span className="absolute left-5 top-4 text-4xl font-black tracking-tight text-white/90" data-id="element-287" data-mp="tgpcxvme2b4p">{COLLECTION_NUMBERS[index]}</span>
                  <span className="absolute bottom-4 right-5 rounded-none border border-nordvik-orange/70 bg-nordvik-ink/70 px-3 py-1 text-[10px] uppercase tracking-[0.15em] text-nordvik-orange" data-id="element-288" data-mp="ye91ppgpq6aw">Live calendar</span>
                </div>
                <div className="nv-rail mt-5 pl-5" data-id="element-289" data-mp="1qxo5xg84dqld">
                  <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-290" data-mp="209llgty9yhpu">
                    <div data-id="element-291" data-mp="1w9uw8uoec9nf">
                      <h3 className="text-2xl font-black uppercase tracking-tight text-white" data-id="element-292" data-mp="1w8jtmy6ot7xw">{villa.name}</h3>
                      <p className="mt-2 max-w-md text-sm leading-relaxed text-white/55" data-id="element-293" data-mp="29zokpbvzorwm">{villa.shortDescription}</p>
                    </div>
                    <ArrowUpRight className="mt-1 h-5 w-5 text-white/35 transition-colors group-hover:text-nordvik-orange" aria-hidden="true" data-id="element-294" data-mp="1hbiyslt78wv7" />
                  </div>
                  <div className="mt-5 flex gap-5 border-t border-white/10 pt-4 text-[10px] uppercase tracking-[0.15em] text-white/45" data-id="element-295" data-mp="1dca9pu93tn5z">
                    <span className="text-white" data-id="element-296" data-mp="1macgyrjflc1p">${villa.nightlyRate} nightly</span>
                    <span data-id="element-297" data-mp="32p5eacvcieuf">Sleeps {villa.sleeps}</span>
                    <span data-id="element-298" data-mp="32nkf29y367q8">{villa.bedrooms} beds</span>
                  </div>
                </div>
              </Link>
            </motion.article>)}
        </div>
      </section>
    </main>;
};